import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import customEventBus from '@common/scripts/libs/eventBus';
import ContactDetailsCore from './ContactDetailsCore';
const ContactDetails = (props) => {
    const { t } = useTranslation();
    const [contactUsUrl, setContactUsUrl] = useState();
    useEffect(() => {
        customEventBus.on('contacts:selected-country', updateContacts);
        return () => {
            customEventBus.off('contacts:selected-country', updateContacts);
        };
    }, []);
    const updateContacts = (data) => {
        var _a, _b;
        ((_b = (_a = data === null || data === void 0 ? void 0 : data.csdata) === null || _a === void 0 ? void 0 : _a.contactUs) === null || _b === void 0 ? void 0 : _b.url) && setContactUsUrl(data.csdata.contactUs.url);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames('contact-details', { 'clothing-contact': window.isClothing }) },
            React.createElement("div", { className: "container" },
                props.description && React.createElement("p", { className: "contact-details__description primary-m" }, props.description),
                !window.isClothing && React.createElement(ContactDetailsCore, { type: "LIST" }),
                contactUsUrl && (React.createElement("a", { className: "button button--secondary", href: contactUsUrl }, t('clientservice.contactus')))))));
};
export default ContactDetails;
